//Sustituye los espacios de un string por "_"
export const replaceStringSpaces = (string) => {
  return string.replace(/\s/g, '_')
}

//Cambia los "_" por espacios. Usada para parsear
//las string devueldas por replaceStringSpaces()
export const addStringSpaces = (string) => {
  return string.replace(/_/g, ' ')
}

//Transforma las fechas al formato 'yyyy-MM-dd HH:MM'
export const getDateTime = () => {
  const date = new Date()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  const year = date.getFullYear()
  const hour = ('0' + date.getHours()).slice(-2)
  const minute = ('0' + date.getMinutes()).slice(-2)
  return `${year}-${month}-${day} ${hour}:${minute}`
}

//make a booker
export const isEmptyMake = (value) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]*[^\s][A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]*$/
  return regex.test(value)
}

//Valida si un string esta vacio
export const isEmpty = (value) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]+$/
  return regex.test(value)
}

export const isEmptyLastName = (value) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]+$/
  return regex.test(value)
}

export const isEmptyGifted = (value) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]+$/
  return regex.test(value)
}

export const isEmptyLastNameGifted = (value) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]+$/
  return regex.test(value)
}

//Valida si un correo tiene le formato correcto
export const isEmailValid = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const isEmailValidGifted = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const isEmptyPaymentType = (value) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]+$/
  return regex.test(value)
}

export const isEmptyWayToPay = (value) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]+$/
  return regex.test(value)
}
export const isEmptyPlatform = (value) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]+$/
  return regex.test(value)
}

export const isEmptyOtherPlatform = (value) => {
  const regex = /^[A-Za-záéíóúÁÉÍÓÚüÜñÑ\s]+$/
  return regex.test(value)
}
//transforma las fechas a un formato que el cliente vera en el frontend
export const formatDates = (date) => {
  const newDate = new Date(date)

  const d = newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()
  const m =
    newDate.getMonth() + 1 < 10
      ? `0${newDate.getMonth() + 1}`
      : newDate.getMonth() + 1
  const y = newDate.getFullYear()
  // dd/mm/yyyy
  const formatDate = d + '/' + m + '/' + y

  return formatDate
}

//Suma los elementos de un array
export const addArrayItems = (array) => {
  return array.reduce((a, b) => a + b, 0)
}

//Pasa una string a slug, sustituye los espacios por '-'
export const formatUrlToSlug = (string) => {
  return string.replace(/\s/g, '-')
}

// Pasa un slug a string, sustituye los '-' por espacios
export const formatSlugToUrl = (string) => {
  return string.replace(/-/g, ' ')
}

//si tiene los caracteres especiales === true
export const validateSpecialCharSlug = (string) => {
  const format = /[ñ0123456789!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]+/

  if (format.test(string)) {
    return true
  } else {
    return false
  }
}

export const validateSpecialChar = (string) => {
  const format = /[0123456789!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]+/

  if (format.test(string)) {
    return true
  } else {
    return false
  }
}

//embebe los videos de youtube
export const embedYoutubeVideo = (url) => {
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
  const match = url.match(regExp)

  if (match && match[2].length === 11) {
    return match[2]
  } else {
    return 'error'
  }
}

//transforma las fechas para ser guardadas en la base de datos
export const formatDateToDB = (date) => {
  const newDate = new Date(date)

  const d = newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()
  const m =
    newDate.getMonth() + 1 < 10
      ? `0${newDate.getMonth() + 1}`
      : newDate.getMonth() + 1
  const y = newDate.getFullYear()
  // yyyy-mm-dd
  const formatDate = y + '-' + m + '-' + d

  return formatDate
}

//Transforma las fechas de la DB para ser mostradas en el FrontEnd
//Recibe formato yyy-mm-dd y lo cambia a dd-mm-yyy
export const formatDBDate = (date) => {
  try {
    // Asegurar que date sea un objeto de fecha
    const newDate = new Date(date)

    // Ajustar la fecha a la zona horaria local (puedes ajustar esto según tus necesidades)
    const adjustedDate = new Date(
      newDate.getUTCFullYear(),
      newDate.getUTCMonth(),
      newDate.getUTCDate(),
      newDate.getUTCHours(),
      newDate.getUTCMinutes(),
      newDate.getUTCSeconds(),
    )

    // Obtener los componentes de la fecha y agregar ceros a la izquierda si es necesario
    const day =
      adjustedDate.getDate() < 10
        ? `0${adjustedDate.getDate()}`
        : adjustedDate.getDate()
    const month =
      adjustedDate.getMonth() + 1 < 10
        ? `0${adjustedDate.getMonth() + 1}`
        : adjustedDate.getMonth() + 1

    // Formatear la fecha y reemplazar barras con guiones
    const formattedDate = `${day}-${month}-${adjustedDate.getFullYear()}` // Cambia el orden según tus preferencias

    return formattedDate
  } catch (error) {
    console.error('Error al formatear la fecha:', error)
    return 'Fecha inválida'
  }
}

//Color random
export const rondomColor = () => {
  const color = Math.floor(Math.random() * 16777215).toString(16)
  return '#' + color
}

//Eliminar duplicados de un array de objetos
export const reduceArrayOfObjects = (prop) => (arr) =>
  Object.values(
    arr.reduce(
      (acc, item) =>
        item && item[prop]
          ? { ...acc, [item[prop]]: item } // just include items with the prop
          : acc,
      {},
    ),
  )

//Valida que fecha este en el rango
//Input format: yyyy-mm-dd
export const checkDateIsBetweenRange = (current, startDate, endDate) => {
  const dateToCheck = new Date(current.split('-'))
  const dateFrom = new Date(startDate.split('-'))
  const dateTo = new Date(endDate.split('-'))
  dateToCheck.setHours(0, 0, 0, 0)
  dateFrom.setHours(0, 0, 0, 0)
  dateTo.setHours(0, 0, 0, 0)

  return dateToCheck >= dateFrom && dateToCheck <= dateTo
}

export const capitalizeFirstLetter = (string) => {
  if (!!string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  } else {
    return ''
  }
}

//Input format: new Date()
//Output format: yyyy-mm-dd
export const rangeBetweenDates = (startDate, stopDate) => {
  var dateArray = []
  var currentDate = startDate

  while (currentDate <= stopDate) {
    dateArray.push(formatDateToDB(new Date(currentDate)))
    var dat = new Date(currentDate.valueOf())
    dat.setDate(dat.getDate() + 1)
    currentDate = dat
  }
  return dateArray
}

export const objectIsEmpty = (obj) => {
  return Object.keys(obj).length === 0
}

export const getNameCategory = (category) => {
  switch (category) {
    case 'AGENCY':
      return 'Operador turístico'
    case 'HOTEL':
      return 'Alojamientos'
    case 'RESTAURANT':
      return 'Restaurantes'
    case 'ECOMMERCE':
      return 'Tienda online'
    default:
      return ''
  }
}

export const stringToSlug = (str) => {
  str = str.replace(/^\s+|\s+$/g, '') // trim
  str = str.toLowerCase()

  // remove accents, swap ñ for n, etc
  var from = 'àáãäâèéëêìíïîòóöôùúüûñç·/_,:;'
  var to = 'aaaaaeeeeiiiioooouuuunc------'

  for (var i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
  }

  str = str
    .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
    .replace(/\s+/g, '-') // collapse whitespace and replace by -
    .replace(/-+/g, '-') // collapse dashes

  return str
}
